<template>
  <div>
    <h4>Estoque</h4>
    <b-row>
      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Movimentação do item:</h4>
              <b-row>
                <b-col md="12">
                  <VueSelect placeholder="Informe a descrição do produto" ref="buscarProduto" label="id"
                    :filterable="false" @input="setProduto" v-model="valueProduto" :options="produtos"
                    @search="onSearchProduto">
                    <template slot="no-options">
                      Informe a descrição do produto
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.descricao }}
                      </div>
                    </template>
                  </VueSelect>
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col md="6">
                  <b-form-group id="data_inicial_movimentacao" label-for="data_inicial_movimentacao"
                    label="Data Inicial">
                    <b-form-input type="date" v-model="data_inicial_movimentacao">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="data_final_movimentacao" label-for="data_final_movimentacao" label="Data final">
                    <b-form-input type="date" v-model="data_final_movimentacao">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <br />
              <button @click="gerarMovimentacaoProduto()" class="btn btn-primary font-weight-bold">
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>


      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Lista de preços:</h4>
              <b-row>
                <b-col md="6">
                  <b-form-group id="imprimir_custo" label-for="imprimir_custo" label="Imprimir Custo">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setImprimirCusto" :checked="imprimir_custo" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="imprimir_grupo" label-for="imprimir_grupo" label="Imprimir Grupo">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setImprimirGrupo" :checked="imprimir_grupo" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group id="imprimir_preco" label-for="imprimir_preco" label="Imprimir Preço">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setImprimirPreco" :checked="imprimir_preco" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="imprimir_quantidade" label-for="imprimir_quantidade" label="Imprimir Quantidade">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setImprimirQuantidade"
                          :checked="imprimir_quantidade" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group id="considerar_estoque" label-for="considerar_estoque"
                    label="Considerar somente produtos com estoque">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setProdutosEstoqueZerado"
                          :checked="considerar_estoque" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="imprimir_fornecedor" label-for="imprimir_fornecedor" label="Imprimir Fornecedor">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setFornecedorLista"
                          :checked="imprimir_fornecedor" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group id="imprimir_referencia" label-for="imprimir_referencia" label="Imprimir Referência">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setReferenciaLista"
                          :checked="imprimir_referencia" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="considerar_ativos" label-for="considerar_ativos"
                    label="Considerar somente produtos ativos">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setConsiderarAtivos"
                          :checked="considerar_ativos" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group id="imprimir_marca" label-for="imprimir_marca" label="Imprimir Marca">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setImprimirMarca" :checked="imprimir_marca" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="imprimir_codigo_barra" label-for="imprimir_codigo_barra"
                    label="Imprimir Código Barras">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setImprimirCodigoBarra"
                          :checked="imprimir_codigo_barra" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group id="cfop_item" label-for="cfop_item" label="CFOP">
                    <b-form-input id="cfop_item" name="cfop_item" type="text" v-model="cfop_item"
                      maxlength="4"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Escolha a ordenação" label-for="ordenacao">
                    <select name="ordenacao_lista_preco" id="ordenacao_lista_preco" v-model="ordenacao_lista_preco"
                      class="form-control">
                      <option v-for="(o, index) in ordenar_lista_preco" :value="o.campo" :key="'campo' + index">
                        {{ o.descricao }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Tipo do produto" label-for="tipo_produto">
                    <select name="tipo_produto" id="tipo_produto" v-model="tipo_produto" class="form-control">
                      <option v-for="(t, index) in tipos" :value="t.id" :key="'campo' + index">
                        {{ t.descricao }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group label="Grupo" label-for="grupos">
                    <VueSelect ref="buscarGrupoProduto" :filterable="false" :options="grupos" @open="onSearchGrupo" @search="onSearchGrupo"
                      v-model="grupoSelected">
                      <template slot="no-options">
                        Informe o grupo pelo descrição
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex justify-content-between">
                          <div>{{ option.nome }}</div>
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">{{ option.nome }}</div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group label="% para aplicar no preço de venda" label-for="percentual_preco">
                    <money class="form-control" v-model="percentual_preco" v-bind="configMoney" />
                  </b-form-group>
                </b-col>
              </b-row>
              <button @click="gerarListaDePrecos()" class="btn btn-primary font-weight-bold">
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>

      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Inventário:</h4>
              <b-row>
                <b-col md="6">
                  <b-form-group id="data_limite" label-for="data_limite" label="Data Limite">
                    <b-form-input type="date" v-model="data_limite">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="livro" label-for="livro" label="Número livro">
                    <b-form-input type="number" v-model="livro"> </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group id="formato_csv" label-for="formato_csv" label="Gerar em formato CSV">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setFormatoCSV" :checked="formato_csv" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group id="mercadoria_revenda" label-for="mercadoria_revenda" label="Somente itens de revenda">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setMercadoriaRevenda" :checked="mercadoria_revenda" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <span v-if="planoBasic" v-b-tooltip.hover title="Disponível a partir do Plano Essencial"
                class="tooltip-wrapper">
                <button class="btn btn-primary font-weight-bold" disabled>
                  Gerar
                </button>
              </span>
              <button v-else @click="gerarInventario()" class="btn btn-primary font-weight-bold">
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>

      <b-col md="12">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Gerar etiqueta do produto:</h4>
              <b-row>
                <b-col sm="12">
                  <VueSelect placeholder="Informe a descrição do produto" ref="buscarProduto" label="id"
                    :filterable="false" @input="setProdutoEtiqueta" v-model="valueProdutoEtiqueta" :options="produtos"
                    @search="onSearchProduto" multiple :selectable="() => valueProdutoEtiqueta.length < 20">
                    <template slot="no-options">
                      Informe a descrição do produto
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.descricao.substring(10, 0) }}
                      </div>
                    </template>
                  </VueSelect>
                </b-col>
              </b-row>
              <br />
              <b-row v-if="valueProdutoEtiqueta.length">
                <b-col sm="12">
                  <h5 class="mb-3">Quantidade de etiquetas por produto</h5>
                </b-col>
                <b-col sm="12" lg="8" xl="7">
                  <div class="d-flex align-items-center font-weight-bold text-muted mb-2">
                    <div class="flex-grow-1 pr-3">Produto</div>
                    <div style="width: 160px;">Qtd. etiquetas</div>
                  </div>
                  <div
                    class="d-flex align-items-center border-top py-2"
                    v-for="produto in valueProdutoEtiqueta"
                    :key="'quantidade-etiqueta-' + getProdutoEtiquetaKey(produto)"
                  >
                    <div class="flex-grow-1 pr-3">
                      <div class="font-weight-bold text-truncate">
                        {{ produto.descricao }}
                      </div>
                    </div>
                    <b-form-input
                      style="width: 160px;"
                      min="1"
                      step="1"
                      type="number"
                      v-model.number="quantidadesEtiqueta[getProdutoEtiquetaKey(produto)]"
                    />
                  </div>
                </b-col>
              </b-row>
              <br v-if="valueProdutoEtiqueta.length" />
              <b-row>
                <b-col sm="2">
                  <b-form-group id="numero_compra" label-for="numero_compra" label="Número da compra">
                    <b-form-input id="numero_compra" name="numero_compra" type="text"
                      v-model="numero_compra"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="3" v-if="numero_compra">
                  <b-form-group id="somente_um_item" label-for="somente_um_item"
                    label="Somente uma etiqueta por produto">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setUmItem" :checked="somente_um_item" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <label>Selecione o modelo da etiqueta</label>
                  <b-form-select v-model="modeloEtiqueta" @input="setModeloEtiqueta">
                    <b-form-select-option v-for="m in modelosEtiqueta" :key="m.id + 'etiquetas'" :value="m">
                      {{ m.descricao }}
                    </b-form-select-option>
                  </b-form-select>
                </b-col>
                <b-col md="3" v-if="modeloEtiqueta && modeloEtiqueta.permite_alteracao">
                  <b-form-group id="linha_inicio" label-for="linha_inicio" label="Linha de Início">
                    <b-form-input id="linha_inicio" name="linha_inicio" type="text"
                      v-model="linha_inicio"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="3" v-if="modeloEtiqueta && modeloEtiqueta.permite_alteracao">
                  <b-form-group id="coluna_inicio" label-for="coluna_inicio" label="Coluna de Início">
                    <b-form-input id="coluna_inicio" name="coluna_inicio" type="text"
                      v-model="coluna_inicio"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="isEtiqueta50x30 && valueProdutoEtiqueta.length">
                <b-col sm="12">
                  <hr />
                  <h5 class="mb-3">Valor a prazo da etiqueta 50x30</h5>
                </b-col>
                <b-col sm="12" lg="8" xl="7">
                  <div class="d-flex align-items-center font-weight-bold text-muted mb-2">
                    <div class="flex-grow-1 pr-3">Produto</div>
                    <div style="width: 160px;">Valor a prazo</div>
                  </div>
                  <div
                    class="d-flex align-items-center border-top py-2"
                    v-for="produto in valueProdutoEtiqueta"
                    :key="'valores-etiqueta-' + getProdutoEtiquetaKey(produto)"
                  >
                    <div class="flex-grow-1 pr-3">
                      <div class="font-weight-bold text-truncate">
                        {{ produto.descricao }}
                      </div>
                    </div>
                    <money
                      class="form-control"
                      style="width: 160px;"
                      :id="'valor_prazo_' + getProdutoEtiquetaKey(produto)"
                      v-model="valoresEtiqueta50x30[getProdutoEtiquetaKey(produto)].valor_prazo"
                      v-bind="configMoney"
                    />
                  </div>
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col sm="6">
                  <b-form-group id="codBarras" label-for="codBarras" label="Gerar código de barra">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setCodBarras" :checked="cod_barras" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group id="preco" label-for="preco" label="Gerar preço de venda">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setPrecoVenda" :checked="preco" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group id="imprimir_logo" label-for="imprimir_logo" label="Impressão da logo">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setImpressaoLogo" :checked="imprimir_logo" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group id="considerar_referencia" label-for="considerar_referencia"
                    label="Considerar referência">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setReferencia" :checked="considerar_referencia" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group id="considerar_codigo_interno" label-for="considerar_codigo_interno"
                    label="Considerar código interno">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setCodigoInterno"
                          :checked="considerar_codigo_interno" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group id="codigo_interno_somente_numeracao" label-for="codigo_interno_somente_numeracao"
                    label="Utilizar somente numeração (código interno)">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true"
                          @change="setCodigoInternoSomenteNumeracao"
                          :checked="considerar_codigo_interno && codigo_interno_somente_numeracao"
                          :disabled="!considerar_codigo_interno" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group id="considerar_codigo_interno" label-for="considerar_codigo_interno"
                    label="Gerar valor por KG">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setValorKG" :checked="valor_por_kg" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4" v-if="!isModeloEtiquetaEditor">
                  <b-form-group id="font_size" label-for="font_size" label="Tamanho da fonte">
                    <b-form-input min="3" max="10" id="font_size" name="font_size" type="number"
                      v-model="font_size"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="12" v-else>
                  <div class="alert alert-light-primary mb-3 py-3" role="status">
                    <i class="fas fa-text-height mr-2"></i>
                    <strong>Tamanhos definidos no modelo de etiqueta.</strong>
                    Para ajustar, abra o modelo no editor de Etiquetas.
                  </div>
                </b-col>
                <b-col sm="12">
                  <b-form-group id="texto_personalizado_etiqueta" label-for="texto_personalizado_etiqueta"
                    label="Texto Personalizado">
                    <b-form-input v-model="texto_personalizado_etiqueta" maxlength="150">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <br />
              <span v-if="planoBasic" v-b-tooltip.hover title="Disponível a partir do Plano Essencial"
                class="tooltip-wrapper">
                <button class="btn btn-primary font-weight-bold" disabled>
                  Gerar
                </button>
              </span>
              <button v-else @click="geraEtiqueta()" class="btn btn-primary font-weight-bold">
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Totalização do estoque:</h4>
              <b-col sm="6">
                <b-form-group id="considerar_somente_qtd" label-for="considerar_somente_qtd"
                  label="Considerar somente produtos com estoque">
                  <span class="switch switch-icon">
                    <label>
                      <input type="checkbox" :value="true" @change="setQuantidadeTot"
                        :checked="considerar_somente_qtd" />
                      <span></span>
                    </label>
                  </span>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group id="apresentar_variacoes_estoque" label-for="apresentar_variacoes_estoque"
                  label="Apresentar variações">
                  <span class="switch switch-icon">
                    <label>
                      <input type="checkbox" :value="true" @change="setApresentarVariacoesEstoque"
                        :checked="apresentar_variacoes_estoque" />
                      <span></span>
                    </label>
                  </span>
                </b-form-group>
              </b-col>
              <span v-if="planoBasic" v-b-tooltip.hover title="Disponível a partir do Plano Essencial"
                class="tooltip-wrapper">
                <button class="btn btn-primary font-weight-bold" disabled>
                  Gerar
                </button>
              </span>
              <button v-else @click="gerarTotalizacaoEstoque()" class="btn btn-primary font-weight-bold">
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Fornecedor preferencial</h4>
              <b-row>
                <b-col md="12">
                  <VueSelect placeholder="Informe o nome do fornecedor" ref="buscarFornecedor" label="id_pessoa"
                    :filterable="false" @input="setFornecedorEstoque" v-model="fornecedorByEstoque"
                    :options="fornecedores" @search="onSearchFornecedor">
                    <template slot="no-options">
                      Informe o nome do fornecedor
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.nome }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.nome }}
                      </div>
                    </template>
                  </VueSelect>
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col sm="12">
                  <b-form-group id="considerar_estoque_positivo" label-for="considerar_estoque_positivo"
                    label="Considerar somente produtos com estoque">
                    <span class="switch switch-icon">
                      <label>
                        <input type="checkbox" :value="true" @change="setEstoquePositivo"
                          :checked="considerar_estoque_positivo" />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <span v-if="planoBasic" v-b-tooltip.hover title="Disponível a partir do Plano Essencial"
                class="tooltip-wrapper">
                <button class="btn btn-primary font-weight-bold" disabled>
                  Gerar
                </button>
              </span>
              <button v-else @click="gerarEstoqueByFornecedor()" class="btn btn-primary font-weight-bold">
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Previsão de Compra</h4>
              <span v-if="planoBasic" v-b-tooltip.hover title="Disponível a partir do Plano Essencial"
                class="tooltip-wrapper">
                <button class="btn btn-primary font-weight-bold" disabled>
                  Gerar
                </button>
              </span>
              <button v-else @click="geararPrevisaoCompra()" class="btn btn-primary font-weight-bold">
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Controle de Lotes:</h4>
              <br />
              <span v-if="planoBasic" v-b-tooltip.hover title="Disponível a partir do Plano Essencial"
                class="tooltip-wrapper">
                <button class="btn btn-primary font-weight-bold" disabled>
                  Gerar
                </button>
              </span>
              <button v-else @click="gerarControleLote()" class="btn btn-primary font-weight-bold">
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>

      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="gerarRastreabilidadeLotes">
            <div class="card-body">
              <h4>Rastreabilidade de lotes</h4>
              <b-form-group label="Produto">
                <VueSelect placeholder="Buscar produto" label="id" :filterable="false"
                  v-model="produtoRastreabilidade" :options="produtos" @search="onSearchProduto">
                  <template slot="option" slot-scope="option">{{ option.descricao }}</template>
                  <template slot="selected-option" slot-scope="option">{{ option.descricao }}</template>
                  <template slot="no-options">Informe o nome do produto</template>
                </VueSelect>
              </b-form-group>
              <b-form-group label="Lote">
                <b-form-input v-model.trim="loteRastreabilidade" placeholder="Número exato do lote" />
              </b-form-group>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Data inicial">
                    <b-form-input type="date" v-model="dataInicialRastreabilidade" />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Data final">
                    <b-form-input type="date" v-model="dataFinalRastreabilidade" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-group label="Modo">
                <b-form-select v-model="modoRastreabilidade" :options="[
                  { value: 'resumido', text: 'Resumido' },
                  { value: 'detalhado', text: 'Detalhado' }
                ]" />
              </b-form-group>
              <div class="mb-3">
                <button
                  type="button"
                  class="btn btn-link p-0"
                  @click="mostrarFiltrosRastreabilidade = !mostrarFiltrosRastreabilidade"
                >
                  {{ mostrarFiltrosRastreabilidade ? 'Menos filtros' : 'Mais filtros' }}
                </button>
              </div>

              <div v-if="mostrarFiltrosRastreabilidade">
                <b-form-group label="Cliente">
                  <VueSelect
                    placeholder="Buscar cliente"
                    label="id_pessoa"
                    :filterable="false"
                    v-model="clienteRastreabilidade"
                    :options="clientes"
                    @search="onSearchCliente"
                  >
                    <template slot="no-options">Informe o nome do cliente</template>

                    <template slot="option" slot-scope="option">
                      {{ option.nome }} - {{ option.cnpj_cpf }}
                    </template>

                    <template slot="selected-option" slot-scope="option">
                      {{ option.nome }} - {{ option.cnpj_cpf }}
                    </template>
                  </VueSelect>
                </b-form-group>

                <b-form-group label="Tipo de documento">
                  <b-form-select
                    v-model="tipoDocumentoRastreabilidade"
                    :options="[
                      { value: 'todos', text: 'Todos' },
                      { value: 'nfe', text: 'NF-e' },
                      { value: 'nfce', text: 'NFC-e' },
                      { value: 'pre_venda', text: 'Pré-venda' },
                      { value: 'pedido', text: 'Pedido' }
                    ]"
                  />
                </b-form-group>
              </div>

              <div class="mt-2">
                <span
                  v-if="planoBasic"
                  v-b-tooltip.hover
                  title="Disponível a partir do Plano Essencial"
                  class="tooltip-wrapper"
                >
                  <button
                    type="button"
                    class="btn btn-primary font-weight-bold"
                    disabled
                  >
                    Gerar
                  </button>
                </span>

                <button
                  v-else
                  type="submit"
                  class="btn btn-primary font-weight-bold"
                >
                  Gerar
                </button>
              </div>
            </div>
          </b-form>
        </div>
      </b-col>

      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Vendas por produto:</h4>
              <b-row>
                <b-col md="12">
                  <b-form-group id="descricao_produto_venda" label-for="descricao_produto_venda"
                    label="Descrição do produto">
                    <b-form-input type="text" v-model="descricao_produto_venda"
                      placeholder="Ex: tenis 43">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="data_inicial_venda_produto" label-for="data_inicial_venda_produto"
                    label="Data Inicial">
                    <b-form-input type="date" v-model="data_inicial_venda_produto">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="data_final_venda_produto" label-for="data_final_venda_produto"
                    label="Data Final">
                    <b-form-input type="date" v-model="data_final_venda_produto">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <button @click="gerarVendasByProduto()" class="btn btn-primary font-weight-bold">
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
    </b-row>
    <hr />
    <h4>Cliente</h4>
    <b-row>
      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Histórico:</h4>
              <b-row>
                <b-col md="12">
                  <VueSelect placeholder="Informe o nome do cliente" ref="buscarCliente" label="id_pessoa"
                    :filterable="false" @input="setCliente" v-model="valueCliente" :options="clientes"
                    @search="onSearchCliente">
                    <template slot="no-options">
                      Informe o nome do cliente
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.nome }} - {{ option.cnpj_cpf }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.nome }} - {{ option.cnpj_cpf }}
                      </div>
                    </template>
                  </VueSelect>
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col md="6">
                  <b-form-group id="data_historico_inicial" label-for="data_historico_inicial" label="Data Inicial">
                    <b-form-input type="date" v-model="data_historico_inicial">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="data_historico_final" label-for="data_historico_final" label="Data Final">
                    <b-form-input type="date" v-model="data_historico_final">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <br />
              <button @click="gerarHistoricoCliente()" class="btn btn-primary font-weight-bold">
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Cadastro de clientes:</h4>
              <br />

              <!-- ABRANGÊNCIA -->
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label="Abrangência"
                    label-for="abrangencia_clientes"
                  >
                    <b-form-radio-group
                      id="abrangencia_clientes"
                      v-model="abrangencia_clientes"
                      name="abrangencia-clientes"
                      buttons
                      button-variant="outline-primary"
                      class="w-100 abrangencia-clientes"
                      @change="onAbrangenciaClientesChange"
                    >
                      <b-form-radio
                        v-for="opcao in opcoes_abrangencia_clientes"
                        :key="opcao.value"
                        :value="opcao.value"
                      >
                        <component
                          :is="opcao.icone"
                          :size="24"
                          class="abrangencia-clientes__icone"
                        />
                        <span>{{ opcao.text }}</span>
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- CIDADE ESPECÍFICA -->
              <b-row v-if="abrangencia_clientes === 'cidade'" class="w-100">
                <b-col md="12">
                  <b-form-group
                    label="Cidade"
                    label-for="cidade_cadastro_clientes"
                  >
                    <VueSelect
                      label="cidade"
                      v-model="cidade_cadastro_clientes"
                      @input="setCidadeCadastroClientes"
                      :options="cidades_cadastro_clientes"
                      placeholder="Selecione uma Cidade"
                      @search="onSearchCidadeCadastroClientes"
                    >
                      <template slot="no-options">
                        Informe o nome da cidade
                      </template>

                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.cidade + " - " + option.uf }}
                        </div>
                      </template>

                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.cidade + " - " + option.uf }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- TODAS AS CIDADES DA UF -->
              <b-row v-if="abrangencia_clientes === 'uf'">
                <b-col md="12">
                  <b-form-group
                    id="uf_selecionada_cadastro_clientes"
                    label-for="uf_selecionada_cadastro_clientes"
                    label="UF"
                  >
                    <VueSelect
                      id="uf_selecionada_cadastro_clientes"
                      v-model="uf_selecionada_cadastro_clientes"
                      label="sigla"
                      :options="ufs_cadastro_clientes"
                      placeholder="Selecione uma UF"
                      @input="setUfCadastroClientes"
                    >
                      <template slot="no-options">
                        Nenhuma UF encontrada
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- TODAS AS UFS -->
              <b-row v-if="abrangencia_clientes === 'todas'">
                <b-col md="12">
                  <strong class="text-muted d-block mb-4">
                    Todas as cidades de todas as UFs serão consideradas.
                  </strong>
                </b-col>
              </b-row>

              <span
                v-if="planoBasic"
                v-b-tooltip.hover
                title="Disponível a partir do Plano Essencial"
                class="tooltip-wrapper"
              >
                <button class="btn btn-primary font-weight-bold" disabled>
                  Gerar
                </button>
              </span>
              <button
                v-else
                @click="gerarReportClientes()"
                class="btn btn-primary font-weight-bold"
              >
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Clientes inativos:</h4>
              <br />
              <b-row>
                <b-col md="6">
                  <b-form-group id="data_inicial_cliente" label-for="data_inicial_cliente" label="Data Inicial">
                    <b-form-input type="date" v-model="data_inicial_cliente">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="data_final_cliente" label-for="data_final_cliente" label="Data Final">
                    <b-form-input type="date" v-model="data_final_cliente">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="8">
                  <b-form-group label="Cidade" label-for="cidade_inativos">
                    <VueSelect label="cidade" @input="setCidadeClienteInativos" :options="cidades" @search="onSearch">
                      <template slot="no-options">
                        Informe o nome da cidade
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.cidade + " - " + option.uf }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.cidade + " - " + option.uf }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
              </b-row>
              <span v-if="planoBasic" v-b-tooltip.hover title="Disponível a partir do Plano Essencial"
                class="tooltip-wrapper">
                <button class="btn btn-primary font-weight-bold" disabled>
                  Gerar
                </button>
              </span>
              <button v-else @click="gerarReportClientesInativos()" class="btn btn-primary font-weight-bold">
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Totalização clientes:</h4>
              <br />
              <span v-if="planoBasic" v-b-tooltip.hover title="Disponível a partir do Plano Essencial"
                class="tooltip-wrapper">
                <button class="btn btn-primary font-weight-bold" disabled>
                  Gerar
                </button>
              </span>
              <button v-else @click="gerarTotalizacaoClientes()" class="btn btn-primary font-weight-bold">
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Aniversariantes:</h4>
              <br />
              <b-row>
                <b-col md="6">
                  <b-form-group label="Escolha o mês" label-for="ordenacao">
                    <select name="mes_aniversariante" id="mes_aniversariante" v-model="mes_aniversariante"
                      class="form-control">
                      <option v-for="(m, index) in meses" :value="m.valor" :key="'campo' + index">
                        {{ m.mes }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
              </b-row>
              <span v-if="planoBasic" v-b-tooltip.hover title="Disponível a partir do Plano Essencial"
                class="tooltip-wrapper">
                <button class="btn btn-primary font-weight-bold" disabled>
                  Gerar
                </button>
              </span>
              <button v-else @click="gerarReportAniversariante()" class="btn btn-primary font-weight-bold">
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col md="4">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Relatório de Atividade:</h4>
              <br />
              <b-row>
                <b-col md="6">
                  <b-form-group id="data_inicial_atividade" label-for="data_inicial_atividade" label="Data Inicial">
                    <b-form-input type="date" v-model="data_inicial_atividade">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="data_final_atividade" label-for="data_final_atividade" label="Data Final">
                    <b-form-input type="date" v-model="data_final_atividade">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="Cidade (opcional)" label-for="cidade_atividade">
                    <VueSelect label="cidade" @input="setCidadeAtividade" :options="cidades" @search="onSearch">
                      <template slot="no-options">
                        Informe o nome da cidade
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.cidade + " - " + option.uf }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.cidade + " - " + option.uf }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
              </b-row>
              <span v-if="planoBasic" v-b-tooltip.hover title="Disponível a partir do Plano Essencial"
                class="tooltip-wrapper">
                <button class="btn btn-primary font-weight-bold" disabled>
                  Gerar
                </button>
              </span>
              <button v-else @click="gerarRelatorioAtividade()" class="btn btn-primary font-weight-bold">
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { SistemaMixin } from "@/modules/Application";
import PessoaMixin from "@/modules/Application/mixins/PessoaMixin";
import swal from "sweetalert";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import MapMarkerOutline from "vue-material-design-icons/MapMarkerOutline.vue";
import OfficeBuildingOutline from "vue-material-design-icons/OfficeBuildingOutline.vue";
import MapOutline from "vue-material-design-icons/MapOutline.vue";
import _ from "lodash";
import { MONEY as settingMoney } from "@/modules/Application";
import { Money } from "v-money";
import loadsh from "loadsh";
import {
  REPORT_PROCESSING_MESSAGE,
  REPORT_WITHOUT_PERIOD_MESSAGE,
} from "@/modules/Relatorios/services/reportGeneration";

export default {
  name: "relatorios",
  mixins: [SistemaMixin, PessoaMixin],
  components: {
    VueSelect,
    Money,
    MapMarkerOutline,
    OfficeBuildingOutline,
    MapOutline,
  },
  data() {
    return {
      valueProduto: null,
      produtoRastreabilidade: null,
      loteRastreabilidade: "",
      dataInicialRastreabilidade: null,
      dataFinalRastreabilidade: null,
      modoRastreabilidade: "resumido",
      mostrarFiltrosRastreabilidade: false,
      clienteRastreabilidade: null,
      tipoDocumentoRastreabilidade: "todos",
      produtos: [],
      clientes: [],
      valueCliente: null,
      data_limite: null,
      livro: null,
      data_inventario: null,
      valueProdutoEtiqueta: [],
      quantidadesEtiqueta: {},
      valoresEtiqueta50x30: {},
      cod_barras: true,
      preco: true,
      repetir: 1,
      modelosEtiqueta: [],
      modeloEtiqueta: {},
      imprimir_custo: true,
      font_size: 3,
      texto_personalizado_etiqueta: null,
      ordenacao_lista_preco: "descricao",
      ordenar_lista_preco: [
        {
          campo: "descricao",
          descricao: "Descrição",
        },
        {
          campo: "codigo",
          descricao: "Código",
        },
      ],
      grupos: [],
      grupo_lista_preco: null,
      imprimir_logo: false,
      considerar_referencia: false,
      fornecedores: [],
      considerar_estoque: false,
      imprimir_grupo: true,
      imprimir_preco: true,
      imprimir_quantidade: false,
      imprimir_fornecedor: false,
      formato_csv: false,
      mercadoria_revenda: false,
      considerar_ativos: true,
      configMoney: settingMoney,
      percentual_preco: null,
      imprimir_marca: false,
      numero_compra: null,
      data_historico_final: null,
      data_historico_inicial: null,
      cidades: [],
      cidades_cadastro_clientes: [],
      cidade_cadastro_clientes: null,
      uf_cadastro_clientes: null,
      uf_selecionada_cadastro_clientes: null,
      ufs_cadastro_clientes: [],
      abrangencia_clientes: "cidade",
      opcoes_abrangencia_clientes: [
        {
          text: "Cidade",
          value: "cidade",
          icone: "MapMarkerOutline",
        },
        {
          text: "Todas da UF",
          value: "uf",
          icone: "OfficeBuildingOutline",
        },
        {
          text: "Todas as UFs",
          value: "todas",
          icone: "MapOutline",
        },
      ],
      considerar_estoque_positivo: true,
      apresentar_variacoes_estoque: false,
      fornecedorByEstoque: null,
      data_inicial_cliente: null,
      data_final_cliente: null,
      cfop_item: null,
      tipos: [],
      tipo_produto: null,
      cidade_inativos: null,
      mes_aniversariante: null,
      meses: [
        {
          mes: "Janeiro",
          valor: "1",
        },
        {
          mes: "Fevereiro",
          valor: "2",
        },
        {
          mes: "Março",
          valor: "3",
        },
        {
          mes: "Abril",
          valor: "4",
        },
        {
          mes: "Maio",
          valor: "5",
        },
        {
          mes: "Junho",
          valor: "6",
        },
        {
          mes: "Julho",
          valor: "7",
        },
        {
          mes: "Agosto",
          valor: "8",
        },
        {
          mes: "Setembro",
          valor: "9",
        },
        {
          mes: "Outubro",
          valor: "10",
        },
        {
          mes: "Novembro",
          valor: "11",
        },
        {
          mes: "Dezembro",
          valor: "12",
        },
      ],
      considerar_somente_qtd: false,
      data_inicial_movimentacao: null,
      data_final_movimentacao: null,
      coluna_inicio: null,
      linha_inicio: null,
      valor_por_kg: false,
      considerar_codigo_interno: false,
      codigo_interno_somente_numeracao: false,
      imprimir_codigo_barra: false,
      planoBasic: false,
      grupoSelected: null,
      data_inicial_atividade: null,
      data_final_atividade: null,
      cidade_atividade: null,
      descricao_produto_venda: null,
      data_inicial_venda_produto: null,
      data_final_venda_produto: null,
    };
  },
  methods: {
    async getDataInit() {
      const [data, ufs] = await Promise.all([
        this.$http.post("/relatorios/modelos-etiquetas"),
        this.getUF(),
      ]);

      if (data) {
        this.modelosEtiqueta = data.data;
      }
      this.ufs_cadastro_clientes = Array.isArray(ufs) ? ufs : [];
      this.getGrupos().then((data) => (this.grupos = data));

      const dataTipos = await this.$http.post("/produtos/tipos");

      this.tipos = dataTipos.data;
    },
    gerarReportAniversariante() {
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_WITHOUT_PERIOD_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/aniversariantes", {
            mes_aniversariante: this.mes_aniversariante,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarTotalizacaoClientes() {
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_WITHOUT_PERIOD_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/totalizacao-clientes")
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    async gerarRastreabilidadeLotes() {
      if (!this.produtoRastreabilidade && !this.loteRastreabilidade
        && (!this.dataInicialRastreabilidade || !this.dataFinalRastreabilidade)) {
        this.$toast.warning("Informe um período para gerar a rastreabilidade de todos os lotes.");
        return;
      }
      if (this.dataInicialRastreabilidade && this.dataFinalRastreabilidade
        && this.dataInicialRastreabilidade > this.dataFinalRastreabilidade) {
        this.$toast.warning("A data final deve ser igual ou posterior à data inicial.");
        return;
      }
      try {
        const response = await this.$http.post("/relatorios/rastreabilidade-lotes", {
          id_produto: this.produtoRastreabilidade ? this.produtoRastreabilidade.id : null,
          lote: this.loteRastreabilidade || null,
          data_inicial: this.dataInicialRastreabilidade,
          data_final: this.dataFinalRastreabilidade,
          id_cliente: this.clienteRastreabilidade ? this.clienteRastreabilidade.id_pessoa : null,
          tipo_documento: this.tipoDocumentoRastreabilidade,
          modo: this.modoRastreabilidade,
        });
        if (response.data && response.data.status) {
          if (response.data.queued) {
            this.$toast.info(response.data.message || "Relat\u00f3rio em processamento.");
            return;
          }
          if (!response.data.data) {
            this.$toast.warning("O relat\u00f3rio ainda n\u00e3o est\u00e1 dispon\u00edvel.");
            return;
          }
          this.$toast.success(response.data.message || "Solicitação realizada com sucesso!");
        } else {
          this.$toast.warning((response.data && response.data.message)
            || "Não houve dados para gerar o relatório.");
        }
      } catch (error) {
        const dadosErro = error.response && error.response.data;
        const primeiroCampo = dadosErro && dadosErro.errors && Object.values(dadosErro.errors)[0];
        this.$toast.error((primeiroCampo && primeiroCampo[0])
          || (dadosErro && dadosErro.message)
          || "Não foi possível gerar o relatório.");
      }
    },
    gerarControleLote() {
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_WITHOUT_PERIOD_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/controle-lotes")
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarReportClientesInativos() {
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_PROCESSING_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/clientes-inativos", {
            data_inicial: this.data_inicial_cliente,
            data_final: this.data_final_cliente,
            cliente: this.cidade_inativos,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    geararPrevisaoCompra() {
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_WITHOUT_PERIOD_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/previsao-compra")
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarTotalizacaoEstoque() {
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_WITHOUT_PERIOD_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/totalizacao-estoque", {
            considerar_somente_qtd: this.considerar_somente_qtd ?? false,
            apresentar_variacoes: this.apresentar_variacoes_estoque ?? false,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarEstoqueByFornecedor() {
      if (!this.fornecedorByEstoque) {
        this.$toast.warning(
          "Selecione o fornecedor que deseja ver os produtos!"
        );
        return;
      }
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_WITHOUT_PERIOD_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/fornecedor-estoque", {
            considerar_estoque_positivo: this.considerar_estoque_positivo,
            fornecedorByEstoque: this.fornecedorByEstoque,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarListaDePrecos() {
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_WITHOUT_PERIOD_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/lista-preco", {
            imprimir_custo: this.imprimir_custo,
            ordenacao_lista_preco: this.ordenacao_lista_preco,
            grupo_lista_preco: this.grupoSelected ?? null,
            considerar_estoque: this.considerar_estoque ?? null,
            imprimir_grupo: this.imprimir_grupo ?? null,
            imprimir_preco: this.imprimir_preco ?? null,
            imprimir_quantidade: this.imprimir_quantidade ?? null,
            imprimir_fornecedor: this.imprimir_fornecedor ?? null,
            considerar_ativos: this.considerar_ativos ?? null,
            percentual_preco: this.percentual_preco ?? null,
            imprimir_referencia: this.imprimir_referencia ?? null,
            imprimir_marca: this.imprimir_marca ?? null,
            cfop_item: this.cfop_item ?? null,
            tipo_produto: this.tipo_produto ?? null,
            imprimir_codigo_barra: this.imprimir_codigo_barra ?? false,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarMovimentacaoProduto() {
      if (!this.valueProduto) {
        this.$toast.warning(
          "Selecione o produto que deseja ver a movimentação!"
        );
        return;
      }
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_PROCESSING_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/movimentacao-produto", {
            id: this.valueProduto.id,
            data_inicial_movimentacao: this.data_inicial_movimentacao,
            data_final_movimentacao: this.data_final_movimentacao,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarVendasByProduto() {
      if (
        !this.descricao_produto_venda ||
        !this.descricao_produto_venda.trim()
      ) {
        this.$toast.warning(
          "Informe a descrição do produto para gerar o relatório!"
        );
        return;
      }
      if (
        !this.data_inicial_venda_produto ||
        !this.data_final_venda_produto
      ) {
        this.$toast.warning("Informe as datas para gerar o relatório!");
        return;
      }
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_PROCESSING_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/vendas-by-produto", {
            descricao_produto: this.descricao_produto_venda.trim(),
            data_inicial: this.data_inicial_venda_produto,
            data_final: this.data_final_venda_produto,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarHistoricoCliente() {
      if (!this.valueCliente) {
        this.$toast.warning("Selecione o cliente que deseja ver o histórico!");
        return;
      }
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_PROCESSING_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/historico-cliente", {
            id: this.valueCliente.id_pessoa,
            tela: false,
            data_historico_final: this.data_historico_final ?? null,
            data_historico_inicial: this.data_historico_inicial ?? null,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarInventario() {
      if (!this.data_limite) {
        this.$toast.warning("Informe a data limite para gerar o relatório!");
        return;
      }
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: "Aguarde, pois será notificado no menu quando o relátorio será gerado!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/inventario", {
            data_limite: this.data_limite,
            livro: this.livro,
            formato_csv: this.formato_csv,
            mercadoria_revenda: this.mercadoria_revenda ?? false,
          })
          .then((response) => {
            swal.stopLoading();
            swal.close();
            if (response.data) {
              window.open(response.data.url_report, "_blank");
            }
            this.$toast.success("Inventário gerado com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    getProdutoEtiquetaKey(produto) {
      return String(
        produto.id || produto.codigo || produto.cod_barras || produto.descricao
      );
    },
    isValorEtiquetaPreenchido(valor) {
      return (
        valor !== null &&
        valor !== undefined &&
        valor !== "" &&
        Number(valor) > 0
      );
    },
    getQuantidadesEtiquetaPayload() {
      const quantidades = {};

      this.valueProdutoEtiqueta.forEach((produto) => {
        const key = this.getProdutoEtiquetaKey(produto);
        const quantidade = parseInt(this.quantidadesEtiqueta[key], 10);

        quantidades[key] =
          Number.isFinite(quantidade) && quantidade > 0 ? quantidade : 1;
      });

      return quantidades;
    },
    hasQuantidadeEtiquetaInvalida() {
      return this.valueProdutoEtiqueta.some((produto) => {
        const key = this.getProdutoEtiquetaKey(produto);
        const quantidade = parseInt(this.quantidadesEtiqueta[key], 10);

        return !Number.isFinite(quantidade) || quantidade < 1;
      });
    },
    getValoresEtiqueta50x30Payload() {
      if (!this.isEtiqueta50x30) {
        return null;
      }

      const valoresEtiqueta50x30 = {};

      this.valueProdutoEtiqueta.forEach((produto) => {
        const key = this.getProdutoEtiquetaKey(produto);
        const valores = this.valoresEtiqueta50x30[key] || {};

        if (this.isValorEtiquetaPreenchido(valores.valor_prazo)) {
          valoresEtiqueta50x30[key] = {
            valor_prazo: Number(valores.valor_prazo),
          };
        }
      });

      return Object.keys(valoresEtiqueta50x30).length
        ? valoresEtiqueta50x30
        : null;
    },
    geraEtiqueta() {
      if (!this.valueProdutoEtiqueta.length && !this.numero_compra) {
        this.$toast.warning("Selecione um produto para geração de etiquetas!");
        return;
      }
      if (!this.modeloEtiqueta) {
        this.$toast.warning("Selecione um modelo de etiqueta!");
        return;
      }
      if (
        this.valueProdutoEtiqueta.length &&
        this.hasQuantidadeEtiquetaInvalida()
      ) {
        this.$toast.warning("Informe uma quantidade válida para cada produto!");
        return;
      }
      const quantidadesEtiqueta = this.getQuantidadesEtiquetaPayload();
      const valoresEtiqueta50x30 = this.getValoresEtiqueta50x30Payload();

      swal({
        title: "Deseja realizar a visualização das etiquetas?",
        text: "Aguarde, pois será notificado no menu quando o relátorio será gerado!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        const payloadEtiqueta = {
          produtos: this.valueProdutoEtiqueta,
          preco: this.preco,
          cod_barras: this.cod_barras,
          repetir: this.repetir,
          quantidades_etiqueta: quantidadesEtiqueta,
          modeloEtiqueta: this.modeloEtiqueta.valor,
          texto_personalizado_etiqueta:
            this.texto_personalizado_etiqueta ?? null,
          imprimir_logo: this.imprimir_logo,
          considerar_referencia: this.considerar_referencia ?? null,
          numero_compra: this.numero_compra ?? null,
          considerar_codigo_interno: this.considerar_codigo_interno ?? false,
          codigo_interno_somente_numeracao: this.codigo_interno_somente_numeracao ?? false,
          somente_um_item: this.somente_um_item ?? false,
          linha_inicio: this.linha_inicio ?? null,
          coluna_inicio: this.coluna_inicio ?? null,
          valor_por_kg: this.valor_por_kg ?? false,
        };

        // Modelos do editor guardam o tamanho em cada elemento. O parâmetro
        // global continua idêntico para etiquetas legadas, mas não pode
        // redimensionar silenciosamente um desenho novo já aprovado.
        if (!this.isModeloEtiquetaEditor) {
          payloadEtiqueta.font_size = this.font_size;
        }

        if (valoresEtiqueta50x30) {
          payloadEtiqueta.valores_etiqueta_50x30 = valoresEtiqueta50x30;
        }

        await this.$http
          .post("/relatorios/etiqueta", payloadEtiqueta)
          .then((response) => {
            swal.stopLoading();
            swal.close();
            if (response["data"]["url_etiqueta"]) {
              window.open(response["data"]["url_etiqueta"], "_blank");
            }
            this.$toast.success("Etiquetas geradas com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    onSearchFornecedor(search, loading) {
      if (search.length) {
        loading(true);
        this.searchFornecedor(loading, search, this);
      }
    },
    searchFornecedor: _.debounce(async (loading, search, vm) => {
      vm.fornecedores = await vm.getFornecedorNome(search);
      loading(false);
    }, 350),
    setFornecedorEstoque(fornecedor) {
      this.fornecedorByEstoque = fornecedor;
    },
    setEstoquePositivo() {
      this.considerar_estoque_positivo =
        this.considerar_estoque_positivo == true ? false : true;
    },
    setProdutosEstoqueZerado() {
      this.considerar_estoque = this.considerar_estoque == true ? false : true;
    },
    setReferencia() {
      this.considerar_referencia =
        this.considerar_referencia == true ? false : true;
    },
    setCodigoInterno() {
      this.considerar_codigo_interno =
        this.considerar_codigo_interno == true ? false : true;
      this.considerar_referencia = false;
      this.cod_barras = false;
      // Se desligar o código interno, a flag de "somente numeração" não faz sentido.
      if (!this.considerar_codigo_interno) {
        this.codigo_interno_somente_numeracao = false;
      }
    },
    setCodigoInternoSomenteNumeracao() {
      this.codigo_interno_somente_numeracao =
        this.codigo_interno_somente_numeracao == true ? false : true;
    },
    setValorKG() {
      this.valor_por_kg = this.valor_por_kg == true ? false : true;
    },
    setImpressaoLogo() {
      this.imprimir_logo = this.imprimir_logo == true ? false : true;
    },
    setPrecoVenda() {
      this.preco = this.preco == true ? false : true;
    },
    setUmItem() {
      this.somente_um_item = this.somente_um_item == true ? false : true;
    },
    setCodBarras() {
      this.cod_barras = this.cod_barras == true ? false : true;
    },
    setImprimirCusto() {
      this.imprimir_custo = this.imprimir_custo == true ? false : true;
    },
    setImprimirGrupo() {
      this.imprimir_grupo = this.imprimir_grupo == true ? false : true;
    },
    setImprimirPreco() {
      this.imprimir_preco = this.imprimir_preco == true ? false : true;
    },
    setImprimirQuantidade() {
      this.imprimir_quantidade =
        this.imprimir_quantidade == true ? false : true;
    },
    setFornecedorLista() {
      this.imprimir_fornecedor =
        this.imprimir_fornecedor == true ? false : true;
    },
    setReferenciaLista() {
      this.imprimir_referencia =
        this.imprimir_referencia == true ? false : true;
    },
    setProdutoEtiqueta(produtos) {
      const produtosSelecionados = produtos || [];
      const quantidadesAtuais = this.quantidadesEtiqueta || {};
      const quantidadesAtualizadas = {};
      const valoresAtuais = this.valoresEtiqueta50x30 || {};
      const valoresAtualizados = {};

      produtosSelecionados.forEach((produto) => {
        const key = this.getProdutoEtiquetaKey(produto);
        quantidadesAtualizadas[key] = quantidadesAtuais[key] || 1;
        valoresAtualizados[key] = {
          valor_prazo: valoresAtuais[key]
            ? valoresAtuais[key].valor_prazo
            : null,
        };
      });

      this.quantidadesEtiqueta = quantidadesAtualizadas;
      this.valoresEtiqueta50x30 = valoresAtualizados;
      this.valueProdutoEtiqueta = produtosSelecionados;
    },
    setModeloEtiqueta(etiqueta) {
      this.possivel_editar = etiqueta;
      this.coluna_inicio = null;
      this.linha_inicio = null;

      if (!etiqueta || etiqueta.valor !== "ARGOX50x30v2") {
        this.valoresEtiqueta50x30 = {};
      }
    },
    setProduto(produto) {
      this.valueProduto = produto;
    },
    setCliente(cliente) {
      this.valueCliente = cliente;
    },
    setFormatoCSV(csv) {
      this.formato_csv = csv == true ? false : true;
    },
    setMercadoriaRevenda(csv) {
      this.mercadoria_revenda = csv == true ? false : true;
    },
    setImprimirMarca() {
      this.imprimir_marca = this.imprimir_marca == true ? false : true;
    },
    setImprimirCodigoBarra() {
      this.imprimir_codigo_barra =
        this.imprimir_codigo_barra == true ? false : true;
    },
    onSearchProduto(search, loading) {
      if (search.length) {
        loading(true);
        this.searchProduto(loading, search, this);
      }
    },
    setConsiderarAtivos() {
      this.considerar_ativos = this.considerar_ativos == true ? false : true;
    },
    setCidadeCadastroClientes(cidade) {
      this.cidade_cadastro_clientes = cidade || null;
      this.uf_cadastro_clientes =
        cidade && cidade.uf ? String(cidade.uf).trim().toUpperCase() : null;
    },
    setUfCadastroClientes(uf) {
      this.uf_selecionada_cadastro_clientes = uf || null;
      this.uf_cadastro_clientes =
        uf && uf.sigla ? String(uf.sigla).trim().toUpperCase() : null;
    },
    onAbrangenciaClientesChange() {
      this.cidade_cadastro_clientes = null;
      this.cidades_cadastro_clientes = [];
      this.uf_cadastro_clientes = null;
      this.uf_selecionada_cadastro_clientes = null;
    },
    setCidadeClienteInativos(cidade) {
      this.cidade_inativos = cidade;
    },
    setCidadeAtividade(cidade) {
      this.cidade_atividade = cidade;
    },
    gerarRelatorioAtividade() {
      if (!this.data_inicial_atividade || !this.data_final_atividade) {
        this.$toast.warning("Informe as datas para gerar o relatório!");
        return;
      }
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_PROCESSING_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/atividade-clientes", {
            data_inicial: this.data_inicial_atividade,
            data_final: this.data_final_atividade,
            cliente: this.cidade_atividade,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    setQuantidadeTot() {
      this.considerar_somente_qtd =
        this.considerar_somente_qtd == true ? false : true;
    },
    setApresentarVariacoesEstoque() {
      this.apresentar_variacoes_estoque =
        this.apresentar_variacoes_estoque == true ? false : true;
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: loadsh.debounce(async (loading, search, vm) => {
      const city = await vm.getCidade(search);
      vm.cidades = city;
      loading(false);
    }, 350),
    onSearchCidadeCadastroClientes(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCidadeCadastroClientes(loading, search, this);
      }
    },
    searchCidadeCadastroClientes: loadsh.debounce(
      async (loading, search, vm) => {
        vm.cidades_cadastro_clientes = await vm.getCidade(search);
        loading(false);
      },
      350
    ),
    gerarReportClientes() {
      if (
        this.abrangencia_clientes === "cidade" &&
        (!this.cidade_cadastro_clientes ||
          !this.cidade_cadastro_clientes.id_cidade)
      ) {
        this.$toast.warning("Selecione uma cidade para gerar o relatório.");
        return;
      }

      if (this.abrangencia_clientes === "uf" && !this.uf_cadastro_clientes) {
        this.$toast.warning("Selecione uma UF para gerar o relatório.");
        return;
      }

      const payload = {
        abrangencia: this.abrangencia_clientes,
        cidade:
          this.abrangencia_clientes === "cidade"
            ? this.cidade_cadastro_clientes
            : null,
        uf_cliente:
          this.abrangencia_clientes === "todas"
            ? null
            : this.uf_cadastro_clientes,
      };

      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: REPORT_WITHOUT_PERIOD_MESSAGE,
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/clientes", payload)
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    searchProduto: _.debounce(async (loading, search, vm) => {
      vm.produtos = await vm.getProdutoByDescricao(search);
      loading(false);
    }, 350),
    onSearchCliente(search, loading) {
      if (search.length) {
        loading(true);
        this.searchClient(loading, search, this);
      }
    },
    searchClient: _.debounce(async (loading, search, vm) => {
      vm.clientes = await vm.getPessoaNome(search);
      loading(false);
    }, 350),
    onSearchGrupo(search, loading) {
      const busca = this.prepararBuscaDireta(search, loading);
      busca.loading(true);
      this.searchGrupo(busca.loading, busca.termo, this);
    },
    searchGrupo: _.debounce(async (loading, search, vm) => {
      vm.grupos = await vm.fetchGrupo(search);
      loading(false);
    }, 350),
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked", "licenca"]),
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
    config() {
      return this.layoutConfig();
    },
    isEtiqueta50x30() {
      return (
        this.modeloEtiqueta && this.modeloEtiqueta.valor === "ARGOX50x30v2"
      );
    },
    isModeloEtiquetaEditor() {
      return Boolean(
        this.modeloEtiqueta && this.modeloEtiqueta.origem_modelo === "editor"
      );
    },
  },
  async mounted() {
    await this.getDataInit();
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }

    if (this.licenca.id_plan == "7") {
      this.planoBasic = true;
    }
  },
};
</script>

<style scoped>
.abrangencia-clientes {
  border: var(--vs-border-width, 1px) var(--vs-border-style, solid)
    var(--vs-border-color, rgba(60, 60, 60, 0.26));
  border-radius: var(--vs-border-radius, 4px);
  overflow: hidden;
}

.abrangencia-clientes ::v-deep .btn {
  align-items: center;
  border: 0;
  border-left: var(--vs-border-width, 1px) var(--vs-border-style, solid)
    var(--vs-border-color, rgba(60, 60, 60, 0.26));
  border-radius: 0;
  display: flex;
  flex: 1 1 0;
  gap: 0.5rem;
  justify-content: center;
  margin-left: 0;
  min-height: 38px;
  padding: 0.55rem 0.35rem;
  white-space: normal;
}

.abrangencia-clientes ::v-deep .btn:first-of-type {
  border-left: 0;
  margin-left: 0;
}

.abrangencia-clientes__icone {
  flex: 0 0 auto;
  line-height: 1;
}

@media (max-width: 575.98px) {
  .abrangencia-clientes {
    flex-direction: column;
  }

  .abrangencia-clientes ::v-deep .btn {
    border-left: 0;
    border-top: var(--vs-border-width, 1px) var(--vs-border-style, solid)
      var(--vs-border-color, rgba(60, 60, 60, 0.26));
    margin-left: 0;
    margin-top: 0;
    width: 100%;
  }

  .abrangencia-clientes ::v-deep .btn:first-of-type {
    border-top: 0;
    margin-top: 0;
  }
}
</style>
